import { openBlock as t, createElementBlock as o, createElementVNode as e } from "vue";
const l = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 32 32"
}, c = /* @__PURE__ */ e("circle", {
  cx: "16",
  cy: "16.592",
  r: "13.333",
  fill: "#fff"
}, null, -1), n = /* @__PURE__ */ e("path", {
  fill: "currentColor",
  d: "M16 3.259a13.333 13.333 0 1 0 0 26.667 13.333 13.333 0 0 0 0-26.667m5.733 10.147-6.093 8a1.334 1.334 0 0 1-2.107.013l-3.253-4.147a1.336 1.336 0 0 1 1.218-2.144 1.34 1.34 0 0 1 .889.504l2.173 2.774 5.04-6.667a1.343 1.343 0 0 1 2.396.634 1.34 1.34 0 0 1-.263.993z"
}, null, -1), r = [
  c,
  n
];
function s(i, a) {
  return t(), o("svg", l, [...r]);
}
const d = { render: s };
export {
  d as default,
  s as render
};
